import React, { useState, useEffect, useRef } from "react";
import queryString from "query-string";
import { Form, Progress, Alert, Input, Container } from "reactstrap";
import { CSSTransition } from "react-transition-group";

import { useLocalization } from "../../containers/I18nProvider";
import { WithCaptcha } from '../../containers/captcha';

import logo from './img/logo.png'

const LoginForm = ({ api, location, TurnstileComponent, ...props }) => {
  const nodeRef = useRef(null);
  const { translate, changeDefaultLocale } = useLocalization();
  changeDefaultLocale('pt-BR');
  const [onLogin, setOnLogin] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [error, setError] = useState({
    open: false,
    message: "",
  });
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const parameters = queryString.parse(location.search);
  parameters.idp = 'niufibra';

  useEffect(() => {
    setShowForm(true)
  }, []);

  const onSubmit = async (ev) => {
    ev.preventDefault();
    setOnLogin(true)
    setError({
      open: false,
      message: "",
    })

    api.userPassLogin(
      {
        username,
        password,
      },
      parameters
    )
      .then((response) => {
        setOnLogin(false)
        window.location = parameters.redirect_uri + "?" + queryString.stringify(response);
      })
      .catch((error) => {
        const _translate = translate(error.errorCode);

        let message = "Houve um erro. Tente novamente";

        if (_translate) {
          message = _translate;
        } else if (error.details) {
          message = error.details;
        }
        setOnLogin(false)
        setError({ open: true, message: message })
      });
  }

  return (
    <CSSTransition
      in={showForm}
      timeout={300}
      classNames="formshow"
      nodeRef={nodeRef}
      unmountOnExit
    >
      <div className="login-niufibra-container" ref={nodeRef}>
        <Form onSubmit={(event) => onSubmit(event)}>
          <Container fluid={true} className="niufibra-form-container">
            <img src={logo} alt="logo" className="logo-niufibra rounded mx-auto d-block" />
            <div style={{ textAlign: 'center' }}>
              <span className="niu-fibra-title">Usuário e Senha cadastrado na Niufibra</span>
            </div>
            <Input
              className="user-input-niufibra"
              disabled={onLogin}
              required={true}
              tabIndex={1}
              type="text"
              autoCorrect="off"
              autoCapitalize="none"
              id="username"
              onChange={e => setUsername(e.target.value)}
              placeHolder={translate("PlaceholderUserName")}
            />
            <Input
              className="pass-input-niufibra"
              required={true}
              disabled={onLogin}
              tabIndex={1}
              type="password"
              autoCorrect="off"
              autoCapitalize="none"
              id="password"
              placeHolder={translate("PlaceholderPassword")}
              onChange={e => setPassword(e.target.value)}
            />
            {!onLogin ? (
              <button
                block={!parameters.failureRedirect}
                tabIndex={1}
                type="submit"
                id="submmit"
                className="enter-niufibra"
                disabled={!props.turnstileSuccess}
              >
                {translate("ButtonEnter")}
              </button>
            ) : (
              <Progress animated color="danger" value={100} />
            )}
            <div className="messages-container">
              <Alert
                color="danger"
                id="error-message"
                isOpen={error.open}
                toggle={() => setError({ open: false })}
              >
                {error.message}
              </Alert>
            </div>
            <TurnstileComponent setTurnstileSuccess={props.setTurnstileSuccess} />
          </Container>
        </Form>
      </div>
    </CSSTransition>
  );
}

export default WithCaptcha(LoginForm, { useInsideForm: true, style: { marginTop: '2rem' } });
